import { TopBar, Frame, Navigation } from "@shopify/polaris";
import { useCallback, useState } from "react";
import { usePartnerUp } from "../providers/PartnerUpProvider";

import partnerUpLogo from "../assets/partner-up-logo.png";
import { useNavigate } from "react-router-dom";
import { HomeMinor, InfoMinor, ProfileMinor } from "@shopify/polaris-icons";

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { profile, signOut, deals } = usePartnerUp();
  // layout
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);

  const toggleUserMenuActive = useCallback(
    () => setUserMenuActive((userMenuActive) => !userMenuActive),
    [],
  );

  const reviewCount = deals.filter(deal => deal.status === 'offerSent').length
  const contentCount = deals.filter(deal => deal.status === 'paid' || deal.status === 'needsContent' || deal.status === 'needsContentAndReview').length
  const messageCount = deals.filter(deal => deal.unreadFor === 'influencer').length

  const notificationCount = reviewCount + contentCount + messageCount

  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive,
      ),
    [],
  )

  const logo = {
    width: 124,
    topBarSource: partnerUpLogo,
    contextualSaveBarSource: partnerUpLogo,
    url: 'https://partnerup.net',
    accessibilityLabel: 'PartnerUp',
  };
  //
  const userMenuActions = [
    {
      items: [{ content: 'Log Out', onAction: signOut }],
    },
  ];
  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={userMenuActions}
      name={profile?.name || "User"}
      detail={profile?.email || ""}
      avatar={profile?.avatar || ""}
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
    />
  );
  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      onNavigationToggle={toggleMobileNavigationActive}
    />
  )
  const navigationMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          {
            label: 'Home',
            icon: HomeMinor,
            selected: window.location.pathname === '/',
            badge: notificationCount ? notificationCount.toString() : null,
            onClick: () => {
              navigate('/')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Earnings',
            icon: InfoMinor,
            selected: window.location.pathname === '/earnings',
            onClick: () => {
              navigate('/earnings')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Profile',
            icon: ProfileMinor,
            selected: window.location.pathname === '/profile',
            onClick: () => {
              navigate('/profile')
            }
          },
          {
            excludePaths: ['#'],
            label: 'Support',
            icon: InfoMinor,
            selected: window.location.pathname === '/support',
            onClick: () => {
              navigate('/support')
            }
          },
        ]}
      />
    </Navigation>
  )

  return (
    <Frame logo={logo} topBar={topBarMarkup} navigation={navigationMarkup} showMobileNavigation={mobileNavigationActive} onNavigationDismiss={toggleMobileNavigationActive}>
      {children}
    </Frame>
  )
}
